/**
 * @generated SignedSource<<3eea0932994274fb73bcd948ee86fb78>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ticket"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "ticket",
            "variableName": "ticket"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticket",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AcceptInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserInvitation",
                    "kind": "LinkedField",
                    "name": "waitingUserInvitation",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AcceptInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserInvitation",
                    "kind": "LinkedField",
                    "name": "waitingUserInvitation",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2ea9ab36031bb84967c49412c175767a",
            "id": null,
            "metadata": {},
            "name": "AcceptInviteQuery",
            "operationKind": "query",
            "text": "query AcceptInviteQuery(\n  $ticket: String!\n) {\n  waitingUserInvitation(ticket: $ticket) {\n    email\n    ticket\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "744d1c6511b7b3b73e2828f9f75417d9";
export default node;
